export enum AccountModalityEnum {
  CHECKING = 'Corrente',
  GUARANTEED = 'Garantida',
  SAVINGS = 'Poupança',
  PAYMENT = 'Pagamento'
}
